// Schema for Transportation vendor-type-specific fields.

import { RENTAL_TIME_MIN_OPTIONS, RENTAL_TIME_MAX_OPTIONS, FLEET_TYPES, TRANSPORT_SERVICES, VEHICLE_AMENITIES, SPECIAL_TRANSPORTATION } from '../constants/vendorOptions';

// Full chronological order for validating rental time — MIN_OPTIONS already
// covers 'No Min' through '7 Hours' in order; MAX_OPTIONS' remaining entries
// ('8 Hours' through 'No Max') are appended to complete the sequence.
const RENTAL_TIME_ORDER = [...RENTAL_TIME_MIN_OPTIONS, ...RENTAL_TIME_MAX_OPTIONS.slice(7)];

export const transportationSchema = {
  vendorType: 'Transportation',
  fields: [
    {
      type: 'row',
      fields: [
        { key: 'transportStartingPrice', type: 'price', label: 'Starting Price', optional: true },
        { key: 'transportAvgPrice', type: 'price', label: 'Average Price', optional: true },
      ],
    },
    { key: 'chaufferIncluded', type: 'checkbox', label: 'Chauffeur Included' },
    {
      type: 'row',
      fields: [
        { key: 'minRentalTime', type: 'select', label: 'Min Rental Time', options: RENTAL_TIME_MIN_OPTIONS, optional: true },
        { key: 'maxRentalTime', type: 'select', label: 'Max Rental Time', options: RENTAL_TIME_MAX_OPTIONS, optional: true },
      ],
    },
    { key: 'fleetTypes', type: 'chips', label: 'Fleet', options: FLEET_TYPES, optional: true },
    { key: 'transportServices', type: 'chips', label: 'Services', options: TRANSPORT_SERVICES, optional: true },
    { key: 'vehicleAmenities', type: 'chips', label: 'Vehicle Amenities', options: VEHICLE_AMENITIES, optional: true },
    { key: 'specialTransportation', type: 'chips', label: 'Special Transportation', options: SPECIAL_TRANSPORTATION, optional: true },
  ],
  priceValidations: [
    { startingKey: 'transportStartingPrice', avgKey: 'transportAvgPrice' },
  ],
  selectRangeValidations: [
    { minKey: 'minRentalTime', maxKey: 'maxRentalTime', orderedOptions: RENTAL_TIME_ORDER },
  ],
};